import { Component, Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { UsuarioLoginEntity } from "../../../views/login/usuario_login_entity";
import { SessionStorageService } from "ngx-webstorage/dist/services";
const swal = require("sweetalert2");
declare var jQuery:any;

@Injectable()
export class HandleError {
    usuarioLogin: UsuarioLoginEntity;
    constructor(private router: Router, public sesionStorageService: SessionStorageService) { }
    redirectUrl(error: any): void {
        switch (error.status) {
            case 404:
                this.router.navigate(["/error/404"]);
                break;
            case 500:
                this.router.navigate(["/error/500"]);
                break;
            case 999:
            case 401:
                this.usuarioLogin = jQuery.parseJSON(this.sesionStorageService.retrieve("usuarioLogin"));
                let bandera401 = this.usuarioLogin.Tipo;
                swal({
                    title: 'Sesión Caducada',
                    text: "Lo sentimos, su sesión a expirado.",
                    type: 'warning'
                }).then((function(){
                    this.router.navigate(["/login",bandera401]);
                }).bind(this));
                break;
            case 412:
                swal({
                    title: 'Inicio de sesión',
                    text: "Lo sentimos, el usuario y/o contraseña son incorrectos",
                    type: 'warning'
                })
                break;
            case 998:
                this.usuarioLogin = jQuery.parseJSON(this.sesionStorageService.retrieve("usuarioLogin"));
                let bandera998 = this.usuarioLogin.Tipo;
                swal({
                    title: 'Entrada no permitida',
                    text: "Intento de acceso denegado",
                    type: 'error'
                }).then((function(){
                    this.router.navigate(["/login",bandera998]);
                }).bind(this));
                break;
            case 304:
                swal({
                    title: 'Actualización de datos',
                    text: "Lo sentimos, su información no fue actualizada, contactese con su ejecutivo",
                    type: 'error'
                });
                break;
            case 504:
                this.usuarioLogin = jQuery.parseJSON(this.sesionStorageService.retrieve("usuarioLogin"));
                let bandera504 = this.usuarioLogin.Tipo;
                this.router.navigate(["/login",bandera504]);
                break;
        }
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/utils/handleError.component.ts